import { Component, OnInit, ElementRef, ViewChildren, QueryList, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RequestOptions, Headers, ResponseContentType, } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { FormValidator } from '../common/services/formValidator.service';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { ActivitiHandlerService } from '../common/services/activitiHandler.service';
import { SharedService } from '../common/services/sharedService';
import { EmitterService } from '../common/services/emitter.service';
import { PopupComponent } from '../common/utilities/popup/popup.component';
import { Formatter } from '../common/services/formatter';
import { DataLayerService } from '../common/services/dataLayer.service';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { share } from 'rxjs/operators';
@Component({
  selector: 'app-esign-otp',
  templateUrl: './esign-otp.component.html',
  styleUrls: ['./esign.component.css','./esign-otp.component.css']
})
export class EsignOtpComponent implements OnInit {

  public DocumentList: any;
    public PrivewSource = '';
    public OtpForm: FormGroup;
    public Config = { show: false, backdrop: 'static' };
    public config = <CustomModalOptions>{ show: true, backdrop: 'static', closeOption: true };
    public DocumentPreviewPopUpData: any = {};
    public IsViewPdf: boolean;
    public IsPDF: boolean = false;
    public ShowLoader: boolean = false;
    public disable_preview_eSign: boolean = false;
    public ShowBackLoader: boolean = false;
    public IsPriviewSource: boolean = false;
    public preventNavigation: boolean = false;
    public showOTPScreen: boolean = false;
    public IsEmailPresent: boolean = false;
    public mobileNo: string;
    public OtpErrorMsg: string = null;
    public showLoanAgreementForm: boolean = false;
    public pageVariable = 1;
    public resendOtpFlag = 0;
    public resendOtpExceedFlag: boolean;

    private loanApplicationId: string;
    private contentType: string;
    private documentList: any;

    @ViewChildren(PopupComponent) public popupComponent;
    @ViewChildren(PopupComponent) public popupComponentInstances: QueryList<any>;
    private pdfSource: string;    
    eMOB: string;
    constructor(
        public FormValidator: FormValidator,
        private _activitiHandler: ActivitiHandlerService,
        private _routeContextProvider: RouteContextProvider,
        private _sharedService: SharedService,
        private _emitterService: EmitterService,
        private _formatter: Formatter,
        private _dataLayerService: DataLayerService,
        private _routerService: RouteHandlerService,
        private _cookieHandler: CookieHandlerService,
        private _http: HttpClient,
        private _formBuilder: FormBuilder,
        // private _esignSTSTComponent: EsignSTSTComponent
    ) {
        
    }
    
    public ngOnInit() {
        this.mobileNo  = this._cookieHandler.GetCookie("esignMobile");
        console.log("in Esign OTp",this.mobileNo);
        this.buildOtpForm();
        if(this.mobileNo){
            this.onSendOtp();
        }   
        
        this.intializePopupData();
       
        this.resendOtpFlag = 0;
        const _this = this;        
        window.onbeforeunload = function () { _this.preventNavigation = true; };
    }
    public onSendOtp(){
        this.resendOtpFlag++;
        let reqData = {
            "mobile": this.mobileNo,
            "policyName":"PL",
            "mfa":true,
          }
          if (this.resendOtpFlag <= 6) {
            this.resendOtpExceedFlag = false;
            this._activitiHandler.SendOtp(reqData,true).subscribe((mtResponse) => {
                console.log("Esign OTP Response",mtResponse);
                if(mtResponse.errorBean){
                    this.OtpErrorMsg = mtResponse.errorBean[0].errorMessage;
                }
            })
            
        } else {
            this.OtpErrorMsg = 'You have exhausted all attempts to resend OTP';
            this.resendOtpExceedFlag = true;
        }
       
    }

    
    private intializePopupData() {
        this.DocumentPreviewPopUpData = {
            Id: 'documentPreview',
            Config: <CustomModalOptions>{ show: true },
        };
    }

  
    private buildOtpForm() {
        this.OtpForm = this._formBuilder.group({
            otp: ['', Validators.compose([Validators.required])]
        })
    }
  
    public ShowBundlePopupUp($event: any): void {
        this.getModalDirectiveInstanceBasedOnId(
            $event.currentTarget.attributes['data-target'].value).show();
    }
    private getModalDirectiveInstanceBasedOnId(popupId: string): any {
        return this.popupComponentInstances.filter((item: PopupComponent) => {
            return item.id === popupId;
        })[0].modalControl;
    }
    public hidePopUp($event) {
        this.config.show = false;
        this.getModalDirectiveInstanceBasedOnId(
            $event.currentTarget.attributes['data-target'].value).hide();
    }
    public OnBack() {
        this.ShowBackLoader = true;
        this._activitiHandler.MarkTaskAsCompleted(
            null,
            'Back',
            true).subscribe((mtResponse) => {
                if (!mtResponse.errorBean) {
                    this.routeToNextRoute(mtResponse.nextTaskKey);
                }
            });
    }
    private routeToNextRoute(nextTaskKey) {
        nextTaskKey = this._formatter.toSmallCase(nextTaskKey);
        this._routerService.RouteToNextTask(nextTaskKey);
    }
    public SubmitOtpForm(formValue) {
        const shareData = this._sharedService.getData("esignData")
        console.log("share data in otp esign",shareData);
        this.ShowLoader = true;
        const requestPayload = {
            otp:formValue.otp,
        mobile:this.mobileNo,
        applicantId:shareData.applicantId || null,
        applicationId:shareData.applicationId || null,
        combinedEsignDocList: shareData.docList}
        
        console.log("otpForm", requestPayload);
        this._activitiHandler.validateOtp(requestPayload).subscribe((mtresponse) => {
            if (!mtresponse.errorBean) {
                this.ShowLoader = false;
                // this._esignSTSTComponent.pageData(formValue);
                if(mtresponse.payload.status="SUCCESS"){
                    this._sharedService.setData("eOtpData",mtresponse.payload.docList); 
                    this._routeContextProvider.NavigateToViewEsign([CommonConstants.Routes.EsignThankYou]);
                }else{
                    this.OtpErrorMsg = mtresponse.errorBean[0].errorMessage; 
                }
                
            } else {
                this.OtpErrorMsg = mtresponse.errorBean[0].errorMessage;
                this.ShowLoader = false;
            }
        });

    }






}